export default __webpack_public_path__ + "static/media/色趣.e73a6fff.png";